import Authentication from "./authentication";
import User from "./modules/user";
import Donamakers from "./modules/donamakers";
import Physicals from "./modules/physicals";
import Legals from "./modules/legals";
import Clients from "./modules/clients";
import Cities from "./modules/cities";
import Districts from "./modules/districts";
import States from "./modules/states";
import Countries from "./modules/countries";
import ScheduleEvents from "./modules/scheduleEvents";
import Coupons from "./modules/coupons";
import Addresses from "./modules/addresses";
import Orders from "./modules/orders";
import Profile from "./modules/profile";
import BankAccounts from "./modules/bankAccounts";
import Notifications from "./modules/notifications";
import Wallets from "./modules/wallets";
import Transfers from "./modules/transfers";
import Account from "./modules/account";
import PaymentGatewayAccount from "./modules/paymentGatewayAccount";
import PaymentGatewayCustomer from "./modules/paymentGatewayCustomer";
import Documents from "./modules/documents";
import Phones from "./modules/phones";
import professionalModules from "./modules/professionals/index";

export default {
  Authentication,
  User,
  Donamakers,
  Physicals,
  Legals,
  Clients,
  Cities,
  Districts,
  States,
  Countries,
  ScheduleEvents,
  Coupons,
  Addresses,
  Orders,
  Profile,
  BankAccounts,
  Notifications,
  Wallets,
  Transfers,
  Account,
  PaymentGatewayAccount,
  PaymentGatewayCustomer,
  Documents,
  Phones,
  ...professionalModules
};



// WEBPACK FOOTER //
// ./src/API/index.js